import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const KpiSkeleton = ({ count = 4 }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <Card key={i} className="p-4">
        <Skeleton className="w-5 h-5 mb-3 rounded" />
        <Skeleton className="h-6 w-24 mb-2" />
        <Skeleton className="h-3 w-16" />
      </Card>
    ))}
  </div>
);

export const TableSkeleton = ({ rows = 6, cols = 5 }) => (
  <Card className="p-0 overflow-hidden">
    <div className="p-4 border-b"><Skeleton className="h-4 w-40" /></div>
    <div className="divide-y divide-border/40">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex items-center gap-4 p-4">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton key={c} className={`h-4 ${c === 0 ? "w-40" : "flex-1"}`} />
          ))}
        </div>
      ))}
    </div>
  </Card>
);

export const AdminSectionSkeleton = () => (
  <div className="space-y-6">
    <KpiSkeleton />
    <Card className="p-5"><Skeleton className="h-4 w-40 mb-4" /><Skeleton className="h-64 w-full" /></Card>
    <TableSkeleton />
  </div>
);
